import { userIsAdminOrModeratorOfSpace } from "@/react/helpers/spaceHelpers";
import { useLargeScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { SortableItem } from "./SortableItem";
import { useSortableBookmarkContext } from "./context/SortableBookmark";

export interface SortableBookmarkItemProps {
  index: number;
}

export const SortableBookmarkItem = ({ index }: SortableBookmarkItemProps) => {
  const { space, bookmark, isFolderDropdownOpen } =
    useSortableBookmarkContext();
  const isMobileScreen = useLargeScreenMediaQuery();

  return (
    <SortableItem
      bookmark={bookmark}
      index={index}
      disabled={
        !userIsAdminOrModeratorOfSpace(space) ||
        isFolderDropdownOpen ||
        isMobileScreen
      }
    />
  );
};
